import { render, staticRenderFns } from "./VariantItemAttribute.vue?vue&type=template&id=12d675c0&"
import script from "./VariantItemAttribute.vue?vue&type=script&lang=js&"
export * from "./VariantItemAttribute.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports